<template>
  <div>
    <div class="echarts" v-if="show">
      <IEcharts :option="bar" :loading="loading" v-if="bar" />
    </div>
  </div>
</template>

<script>
import IEcharts from "vue-echarts-v3/src/full.js";
export default {
  name: "GenericChart",
  components: {
    IEcharts
  },
  props: {
    show: {
      type: Boolean,
      default: true
    },
    startsWith: {
      type: String
    },
    url: {
      type: String
    },
    urlParams: {
      type: Object
    },
    title: {
      type: String
    },
    xAxis: {
      type: Array,
      required: true
    },
    data: {
      type: Array,
      default: () => {
        return [];
      }
    },
    manualYAxis: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    loading: true,
    bar: null
  }),
  methods: {
    getChartData() {
      this.loading = true;
      this.bar = {
        title: {
          text: this.title
        },
        tooltip: {},
        xAxis: {
          data: this.xAxis
        },
        yAxis: {},
        series: [
          {
            //name: "Dia : Cantidad de Interacciones",
            type: "line",
            data: this.data
          }
        ]
      };
      if (this.manualYAxis) {
        this.loading = false;
        return;
      }
      this.$http
        .get(this.url, {
          params: this.urlParams
        })
        .then((resp) => {
          if (resp.data.length > 0) {
            if (this.startsWith) {
              const data = resp.data[0];
              const result = [];
              Object.keys(data).forEach((key) => {
                if (key.startsWith(this.startsWith)) {
                  result.push(data[key]);
                }
              });
              this.bar.series[0].data = result;
            } else {
              this.bar.series[0].data = Object.values(resp.data[0]);
            }
          }
          this.loading = false;
        });
    }
  },
  mounted() {
    this.getChartData();
  },
  watch: {
    show: function (newValue) {
      if (newValue) {
        this.getChartData();
      }
    }
  }
};
</script>

<style scoped>
.echarts {
  width: 93%;
  height: 250px;
  background-color: #f3f7fa;
  border-radius: 30px;
  margin: 30px;
  padding: 10px;
}
</style>
